<template>
  <div :style="{backgroundColor:editablePageConfig.editable_page_config_content.back_color,paddingTop:editablePageConfig.editable_page_config_content.margin_top,paddingBottom:editablePageConfig.editable_page_config_content.margin_bottom}">
  <mt-swipe class="swipper-wrapper" v-bind:style="getBannerStyle" :showIndicators="isShowIndicators">
    <mt-swipe-item v-for="index in editablePageConfig.editable_page_config_content.image[0].count" :key="index">
      <div class="swipper-item" :style="Object.assign({},getBannerStyle,{backgroundImage:'url('+editablePageConfig.editable_page_config_content.image[0].list[index-1].path+')'})" v-if='editablePageConfig.editable_page_config_content.image[0].list[index-1]' @click="goAdUrl(editablePageConfig.editable_page_config_content.link[0].list[index-1].content)"></div>
      <div class="swipper-item" :style="getBannerStyle" style="background-image:url(../../../../assets/image/home/default_image_banner.png)" v-else></div>
    </mt-swipe-item>
  </mt-swipe>
  </div>
</template>

<script>
export default {
  name: 'Model1',
  data () {
    return {
    }
  },
  props: ['editablePageConfig'],
  computed: {
    getBannerStyle: function () {
      let itemWidth = this.editablePageConfig.editable_page_config_content.width
      let itemHeight = this.editablePageConfig.editable_page_config_content.height
      return {
        width: itemWidth,
        height: itemHeight
      }
    },
    isShowIndicators () {
      if (this.editablePageConfig.editable_page_config_content.image[0].count) {
        return true
      }
      return false
    }
  },
  methods: {
    goAdUrl (url) {
      if (url.includes('http://mobile.baixinshangcheng.com/')) {
	// if (url.includes('http://mobilecs.baixinshangcheng.com/')) {
        url = url.match(/com(\S*)/)[1]
        window.location.href = 'https://www.baixinshangcheng.com/wap' + url
		// window.location.href = 'https://newcs.baixinshangcheng.com/wap' + url
      }
    }
  },
  created () {
    // for (let i in this.editablePageConfig.editable_page_config_content.image[0].list) {
    //  console.log(this.editablePageConfig.editable_page_config_content.image[0].list[i].path, '66666---------7777777777-----888')
    //  if(this.editablePageConfig.editable_page_config_content.image[0].list[i].path) {
    // 		  if (this.editablePageConfig.editable_page_config_content.image[0].list[i].path.includes('http://baixinshangcheng.com/uploads/')){
    // 		  	    this.editablePageConfig.editable_page_config_content.image[0].list[i].path = this.editablePageConfig.editable_page_config_content.image[0].list[i].path.match(/com(\S*)/)[1];
    // 		  		this.editablePageConfig.editable_page_config_content.image[0].list[i].path = 'https://www.baixinshangcheng.com/wap' + this.editablePageConfig.editable_page_config_content.image[0].list[i].path
    // 				console.log(this.editablePageConfig.editable_page_config_content.image[0].list[i].path, '66666---------7777777777-----888')
    // 		  }
    //  }

    // }
    for (let i in this.editablePageConfig.editable_page_config_content.link[0].list) {
      if (this.editablePageConfig.editable_page_config_content.link[0].list[i].content.includes('http://mobile.baixinshangcheng.com/')){
	// if (this.editablePageConfig.editable_page_config_content.link[0].list[i].content.includes('http://mobilecs.baixinshangcheng.com/')){
        this.editablePageConfig.editable_page_config_content.link[0].list[i].content = this.editablePageConfig.editable_page_config_content.link[0].list[i].content.match(/com(\S*)/)[1];
        this.editablePageConfig.editable_page_config_content.link[0].list[i].content = 'https://www.baixinshangcheng.com/wap' + this.editablePageConfig.editable_page_config_content.link[0].list[i].content
		// this.editablePageConfig.editable_page_config_content.link[0].list[i].content = 'https://newcs.baixinshangcheng.com/wap' + this.editablePageConfig.editable_page_config_content.link[0].list[i].content
        console.log(this.editablePageConfig.editable_page_config_content.link[0].list[i].content, '66666---------7777777777-----888')
      }
    }
  }
}
</script>

<style scoped>
.swipper-wrapper{margin: 0 auto}
  .swipper-item{background-size:cover;background-repeat: no-repeat;background-position: center}
</style>
